<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページはDOCTYPE宣言が正しく記述されております。
        </p>
        <p v-else>
          あなたのWebページはDOCTYPE宣言が正しく記述されていません。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          &lt;!DOCTYPE
          html&gt;をhtmlファイルの&lt;html&gt;タグの上に追加してください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
